/*
 * @prop --component-icon-color: The color of system icons
 * @prop --component-icon-color-primary: The primary color of Content icons
 * @prop --component-icon-color-accent:  The accent color of Content icons
 */

:host {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  fill: var(--component-icon-color, var(--current-color-primary, $ui-blue));

  .white {
    --current-color-primary: #{$ui-white};
  }

  .icon-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 100%;

    svg {
      position: absolute;
      top: 0;
      left: 0;
      fill: inherit;
      color: inherit;
      width: 100%;
      height: 100%;
    }
  }
}

:host([type='system'][icon='blog']) {
  svg * {
    &[fill='#00358e' i] {
      fill: var(--skin-color-primary, $ui-blue);
    }

    &[stroke='#00358e' i] {
      fill: var(--skin-color-primary, $ui-blue);
    }
  }
}

:host([type='system']) {
  svg * {
    &[fill='#00358e' i] {
      fill: var(--component-icon-color, var(--current-color-primary, $ui-blue));
    }

    &[stroke='#00358e' i] {
      stroke: var(
        --component-icon-color,
        var(--current-color-primary, $ui-blue)
      );
    }
  }
}

:host([type='content']) {
  svg * {
    &[fill='#00358e' i] {
      fill: var(
        --component-icon-color-primary,
        var(--current-color-primary, $ui-blue)
      );
    }

    &[stroke='#00358e' i] {
      stroke: var(
        --component-icon-color-primary,
        var(--current-color-primary, $ui-blue)
      );
    }

    &[fill='#2d9d00' i] {
      fill: var(
        --component-icon-color-accent,
        var(--skin-color-accent, $ui-green)
      );
    }

    &[stroke='#2d9d00' i] {
      stroke: var(
        --component-icon-color-accent,
        var(--skin-color-accent, $ui-green)
      );
    }
  }
}

// Attrax overrides
:host([type='content']),
:host([type='system']) {
  svg * {
    &[fill='#004073' i] {
      fill: var(--component-icon-color, var(--current-color-primary, $ui-blue));
    }

    &[stroke='#004073' i] {
      stroke: var(
        --component-icon-color,
        var(--current-color-primary, $ui-blue)
      );
    }
  }
}
